// This function allow to reference all chunks
__webpack_require__.cssAssetFileName = (chunkId) => {
	// return url for filenames based on template
	return "loyalty-sign-up-page-" + chunkId + "." + "bb73f9ffc7cb89eabd1d" + ".css";
};